import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { quotePropertyName } from '@cli-utils/text.js'
import { emptyNestedFieldValue } from './empty-nested-field-value.js'

export function objectEntriesForFields(fields: SchemaField[]): string[] {
  return fields.flatMap((field) => {
    const entries = [`${quotePropertyName(field.name)}: ${emptyNestedFieldValue(field)}`]
    if (field.hasIcon) {
      entries.push(`${quotePropertyName(`${field.name}Icon`)}: ''`)
    }
    return entries
  })
}
